import { jwtDecode, JwtPayload } from 'jwt-decode';

export const getAuthTokenFromUrl = (): string | null => {
  const urlParams = new URLSearchParams(window.location.hash.substring(1));

  return urlParams.get('id_token');
};

export const getAuthCodeFromUrl = (): string | null => {
  const urlParams = new URLSearchParams(window.location.search);

  return urlParams.get('code');
};

export const getAuthTokenFromLocalStorage = (): string | null => localStorage.getItem('auth-token');

export const getRefreshTokenFromLocalStorage = (): string | null =>
  localStorage.getItem('refresh-token');

export const setAuthTokenToLocalStorage = (token: string): void =>
  localStorage.setItem('auth-token', token);

export const setRefreshTokenToLocalStorage = (token: string): void =>
  localStorage.setItem('refresh-token', token);

export const removeAuthTokenFromLocalStorage = (): void => localStorage.removeItem('auth-token');

export const removeRefreshTokenFromLocalStorage = (): void =>
  localStorage.removeItem('refresh-token');

export const isExpireToken = (token: string): boolean => {
  const decodedToken: JwtPayload = jwtDecode(token);

  const now: Date = new Date();

  return (decodedToken.exp ?? 0) * 1000 < now.getTime();
};
